import * as React from 'react'
import { useTranslations } from 'next-intl'
import { tw } from 'utils/classnames'
import { AppRoutesParameterized } from '@repo/web-utils/app-routes'
import { Link } from '@repo/web-ui/components/link'
import { useClubhousesFromUserQuery } from '@web/gen/crafter'
import { getClubhouseDetails } from '@web/app/[locale]/clubhouse/_components/constants'

export function ClubhousesSectionV2({ userId }: { userId: string }) {
  const t = useTranslations('social-feed.components.feed.post')
  const { data: clubhouses } = useClubhousesFromUserQuery(
    {
      input: { userId, page: 0, itemsPerPage: 15 },
    },
    { select: data => data?.clubhousesFromUser?.clubhouses },
  )
  const clubhousesWithIcons = React.useMemo(
    () =>
      clubhouses?.map(clubhouse => ({
        ...clubhouse,
        icon: getClubhouseDetails(clubhouse.slug)?.icon,
      })),
    [clubhouses],
  )
  return (
    <div className="flex flex-col w-full gap-2">
      <div className="flex w-full justify-between items-center">
        <div>
          <span className="font-bold text-cf-grey-1000 text-14 pr-1">{t('clubhouses')}</span>
          <span className="text-cf-grey-500 text-10 font-semibold bg-cf-grey-200 border border-[#1313151F] px-1.5  rounded-[24px]">
            {clubhouses?.length || 0}
          </span>
        </div>
      </div>
      {clubhousesWithIcons?.length ? (
        <div className="border border-[#1313151F] rounded-2">
          {clubhousesWithIcons.slice(0, 5).map(clubhouse => (
            <Link
              className="flex flex-row items-center justify-start gap-2 py-2 px-3 border-b border-[#1313151F] last:border-b-0 hover:bg-cf-grey-100 active:bg-cf-grey-200 first:rounded-t-2 last:rounded-b-2"
              key={clubhouse.slug}
              href={AppRoutesParameterized.CLUBHOUSE(clubhouse.slug)}
            >
              <span
                className={tw(
                  'flex h-[24px] w-[24px] shrink-0 items-center justify-center rounded-full p-1 text-cf-white',
                  clubhouse.bgColor ? `bg-[${clubhouse?.bgColor}]` : 'bg-cf-white',
                )}
              >
                {clubhouse?.icon ?? null}
              </span>
              <span className="text-14 font-semibold text-cf-grey-800">{clubhouse.name}</span>
            </Link>
          ))}
        </div>
      ) : null}
    </div>
  )
}
